export enum PresentationMode {
  DEFAULT,
  // AP2 = Arbeitsplatz #2
  // An diesem Arbeitsplatz werden die bereits erfassten Anträge importiert und
  // um weitere Daten eingereichert. In diesem Modus sind die importierten Daten
  // nicht editierbar.
  AP2,
}

export enum ErrorCode {

  // "Wertelisten konnten nicht geladen werden."
  LOAD_VALUELISTS_ERROR,

  // "Validierungsmetadaten konnten nicht geladen werden."
  LOAD_VALIDATION_METADATA_ERROR,

  // "Komponente zur Bieometrieerfassung wurde nicht gefunden oder ist nicht gestartet. Bitte
  //  Starten sie Windows neu. Sollte das Problem weiter bestehen, bitte wenden Sie sich an den Administrator."
  LOAD_DEVICES_ERROR,

  // "Keine Berechtigung"
  LOAD_IS_AP2_MODE_ERROR
}
